module.exports = __webpack_public_path__ + "static/1-d6556464fde5a736bb9422c2412dd807.mp4";